import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=03311e4d&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=03311e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03311e4d",
  null
  
)

export default component.exports